export default __webpack_public_path__ + "static/media/1.32c2a7a8.svg";